module.exports = __webpack_public_path__ + "r-v3/img/ml_42_01_over.57845fec.jpg";